import "./allPromotions.css"
import React,{ useEffect} from "react";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import Drawer from '@mui/material/Drawer';
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';

const AllPromotions =( props)=> {
 
    const [promotions, setPromotions] = React.useState(null);
    const [all, setAll] = React.useState(null);
    const [showDrawer, setShowDrawer] = React.useState(false);
    const [currentIndex, setCurrentIndex ] = React.useState(0);
    const [category, setCategoty] = React.useState("all");
    const [search, setSearch] = React.useState("");
    const [filteredPromotions, setFilteredPromotions] = React.useState([]);
    const [index, setIndex] = React.useState(12)


  
    useEffect(()=>{

         setAll(props.data.promotions.items);


       setPromotions(props.data.promotions.items.slice(0,index))

       props.data.categories.items.map(v => ({...v, isActive: false}))
       props.data.categories.items[0].isActive = true;

    },[props.data])

    useEffect(() => {
        if (search!== "") {
            // setFilteredPromotions(
            //     promotions.filter((promo) =>
            //       promo.title.toLowerCase().includes(search.toLowerCase()) 
            //     )
            //   );
              
              const titleFilter =  all.filter((promo) => {
                try {
                    return(promo.title.toLowerCase().includes(search.toLowerCase()) )      
                } catch (error) {
                    return("");
                }
               
              }
              )

                
              const percentFilter =  all.filter((promo) => {
                try {
                    return(promo.establishment.toLowerCase().includes(search.toLowerCase()) )      
                } catch (error) {
                    return("");
                }
               
              }
              )

              const locationFilter =  all.filter((promo) => {
                try {
                    return(promo.address.toLowerCase().includes(search.toLowerCase()) )      
                } catch (error) {
                    return("");
                }
               
              }
              )

            //   const percentFilter =  all.filter((promo) =>
            //     promo.establishment.toLowerCase().includes(search.toLowerCase()) 
            //   )
              
              setFilteredPromotions(titleFilter.concat(percentFilter).concat(locationFilter))

            

        }
      }, [search]);

    const loadCategory = (idcategory) => {
        
        // console.log(idcategory);
        // console.log('items',  props.data.promotions.items)
        var filtered = [];
    
        if (idcategory === "all") {
            filtered = props.data.promotions.items;
        } else {
            props.data.promotions.items.forEach( (element, index) => {
                if (element?.category !== undefined &&  element.category === idcategory) {
                    filtered.push(element)
                }
            });
        }

        // setPromotions(props.data.promotions.items.slice(0,index))
        setAll(filtered);
        setPromotions(filtered.slice(0,12));
        setIndex(12);

        // console.log("filtered", filtered)
        setCategoty(idcategory)


        props.data.categories.items.forEach(element => {
            element.isActive = false;
            if ( element.id === idcategory) {
               element.isActive = true;
            }
        });
    }

    const toggleDrawer = ( open, index) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
          return;
        }
        // console.log('index', index)
        setCurrentIndex(index);
        setShowDrawer(open)
       
    };

    const viewMore = ()=> {
        setPromotions(all.slice(0,index+12))
        setIndex(index+12)
    }

    const clearInputSearch = () => {
        setSearch("");
    }

    

    return(<div className="container promotions-container pt-4 pb-4">
    {/* Hellow from promotions */}
    <div className="prom-title  d-flex justify-content-center">
        <div>
            {documentToReactComponents(props.data.title.json)}
        </div>
    </div>
    

    <div className="row pt-4 pb-4  d-flex justify-content-center ">
        
       {props.data.categories.items.map((item, index)=>{
           return(
             <div id={item.id} key={index} data-promo={item.title} className="col-category  ">
               <div style={{cursor:'pointer'}} onClick={()=>{loadCategory(item.id)}}>
                    <div className="cont-dot d-flex justify-content-center">
                        <div  className={item.isActive ? "dot-category-active d-flex justify-content-center align-items-center" : "dot-category d-flex justify-content-center align-items-center"}>
                            <img  className="col-6 icon-category" src={item.icon} alt={item.icon} />
                        </div> 
                    </div>
                    <div className="col-12 mt-1  text-center category-label">{item.title}</div>
               </div>
             </div>
           )
       })}
    </div>
    <div className="container d-flex justify-content-center pb-4 ">
        <div className="col-12 col-md-6 d-flex justify-content-between ">
            <div className="input-container w-100">
                <SearchIcon  className="searchIcon"/>
                <input value={search} className="form-control input-search" type="text" onChange={(e)=>setSearch(e.target.value)} placeholder="Encuentra promociones, establecimientos o busca por dirección "></input>
            </div>
            { search !== "" && <div style={{color: 'red', cursor:'pointer', margin: '10px', fontWeight: 'bold'}} onClick={clearInputSearch}> X </div> }
        </div>
        
    </div>    
    <div className="container d-flex justify-content-center ">
        {(filteredPromotions !== null && filteredPromotions.length === 0 && search!== "") && <div style={{color:'red'}}>No hay resultados</div>}
    </div>
    <div className="promo-container  pt-3">
         { search === "" ? <div className="row  pb-4">
         {promotions !== null  && promotions.map((item, index)=> {
           return(
               <div key={index} id={"item-promo-"+index} data-promo={item.title + " - "+ item.establishment} className="item-prom  col-12  col-md-4  p-3  ">
                   <div onClick={toggleDrawer(true, index)} className="item-prom-shadow  ">
                       
                       <div className="row  h-100  no-padding ">
                           <div className="col-4  img-promo " style={{backgroundImage:`url(${item.image})`}}>
                       
                           </div>
                           <div className="col-8  pt-1 prom-data ">
                               <div className="title-promo-item"><b>{item.title}</b></div>
                               <div className="establishment  ">
                                    {item.establishment}
                               </div>
                                       <div className="row no-padding">
                                           <div className=" col-percent ">
                                              <b>{item.percent}</b> 
                                           </div>
                                           {item.days.map((day,i)=>{
                                               return(<div key={i} className=" col-day p-1 ">
                                                   {day}
                                               </div>)
                                           })} 
                                       </div>
                                    <br />
                               <div className="pt-1 expire-cont">
                                  <span style={{fontSize: "small"}}>vigencia</span> <span className="expired-label">{item.expire}</span>
                               </div>
                               
                           </div>
                       </div>
                   </div>
               </div>
           )        
         })}  </div> : 
         
         <div className="row  pb-4">
            {/* <div style={{color: 'red', cursor:'pointer'}} onClick={clearInputSearch}>Quitar busqueda X </div> */}
         {filteredPromotions !== null  && filteredPromotions.map((item, index)=> {
           return(
               <div key={index} id={"item-promo-"+index} data-promo={item.title + " - "+ item.establishment} className="item-prom  col-12  col-md-4  p-3  ">
                   <div onClick={toggleDrawer(true, index)} className="item-prom-shadow  ">
                       
                       <div className="row  h-100  no-padding ">
                           <div className="col-4  img-promo " style={{backgroundImage:`url(${item.image})`}}>
                       
                           </div>
                           {/* <div className="col-8  pt-1  ">
                               <h3><b>{item.title}</b></h3>
                                       <div className="row no-padding">
                                           <div className=" col-percent ">
                                              <b>{item.percent}</b> 
                                           </div>
                                           {item.days.map((day,i)=>{
                                               return(<div className=" col-day p-1 " key={i}>
                                                   {day}
                                               </div>)
                                           })} 
                                       </div>
                               <div className="pt-2 ">
                                  <span className="expired-span" style={{fontSize: "small"}}>vigencia</span> <span>{item.expire}</span>
                               </div>
                               
                           </div> */}
                           <div className="col-8  pt-1 prom-data ">
                            <div className="title-promo-item"><b>{item.title}</b></div>
                               <div className="establishment  ">
                                    {item.establishment}
                               </div>
                                       <div className="row no-padding">
                                           <div className=" col-percent ">
                                              <b>{item.percent}</b> 
                                           </div>
                                           {item.days.map((day,i)=>{
                                               return(<div className=" col-day p-1 " key={i}>
                                                   {day}
                                               </div>)
                                           })} 
                                       </div>

                                           

                                    <br />
                               <div className="pt-1 expire-cont">
                                  <span style={{fontSize: "small"}}>vigencia</span> <span className="expired-label">{item.expire}</span>
                               </div>
                               
                           </div>
                       </div>
                   </div>
               </div>
           )        
         })}  
         </div>
         
         }
         
   </div>

   <div className="container text-center">
    <div></div>
    {( all !== null && all.length > 12  ) &&  <div> { index < all.length && <button className="btn-benefit" onClick={viewMore}>VER MÁS </button>} </div>  }
   </div>

   { search === "" ?

   <div className="pb-4">
       <div>
       {
           <React.Fragment key='right'>
           {/* <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button> */}
           <Drawer
               anchor="right"
               open={showDrawer}
               onClose={toggleDrawer(false)}
           >
               <div className="draw-container " >

                   
                   <div className="img-drawer-container ">
                        <CancelIcon onClick={toggleDrawer(false)} fontSize="large" sx={{ color: "#FFF" }} style={{position: 'absolute', top:'10px', left:'10px', cursor: 'pointer'}}/>
                       <img className="img-drawer img-fluid" src={promotions !== null && promotions[currentIndex]?.image } alt="alt" />
                   </div>
                   
                   <div className="main-info-container w-100   p-4" >
                       <div className="w-100 p-2  drawer-shadown-conatiner">
                           <h2><small>{promotions !== null && promotions[currentIndex]?.establishment}</small> </h2>
                           <h2><b>{promotions !== null && promotions[currentIndex]?.percent}</b></h2>
                           <h2> { (promotions !== null && currentIndex!== undefined)  && promotions[currentIndex]?.title } </h2>
                           
                       </div>

                       <div className="w-100  pt-4  ">
                           <p className="" dangerouslySetInnerHTML={{__html: promotions !== null && promotions[currentIndex]?.description}} >
                           </p>
                       </div>

                       <hr />

                       <div className="w-100 p-2  days-drawer-container ">
                           <h3>Cuándo usarlo</h3>
                           <div className="row">
                           {promotions !== null && promotions[currentIndex]?.days.map((day, index)=> {
                               return(<div key={index} className="item-drawer-day">{day}</div>)
                           })}

                           </div>
                       </div>

                       <hr />
                       <div className="expire-container p-2">
                           <p className="pt-2">Vigencia: &nbsp;</p>
                           <h3><b dangerouslySetInnerHTML={{__html: promotions!==null && promotions[currentIndex]?.expire}}></b></h3>
                       </div>

                       <hr />
                       <div className="expire-container p-2">
                           <p className="pt-2">Ubicación: &nbsp;</p>
                           <h3><b dangerouslySetInnerHTML={{__html: promotions!==null && promotions[currentIndex]?.address}}></b></h3>
                       </div>



                       
                       {(promotions!==null && promotions[currentIndex]?.image_info) && 
                       <div>
                            <hr /> 
                            <div className="expire-container p-2">
                                <img className="img-drawer img-fluid" src={promotions!==null && promotions[currentIndex]?.image_info } alt="alt" />
                            </div>
                        </div>
                       }


                       <hr />

                       <div className="legals ">
                           <h3>Legales</h3>

                           <p className="">
                               <small  dangerouslySetInnerHTML={{__html: String(promotions !== null && promotions[currentIndex]?.legals)}}>
                                   {/* {promotions !== null && promotions[currentIndex]?.legals} */}
                               </small>
                           </p>
                       </div>
                   </div>

               </div>
               
           </Drawer>
           </React.Fragment>
       }
       </div>
   </div> : 

    <div className="pb-4">
        <div>
        {
            <React.Fragment key='right'>
            {/* <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button> */}
            <Drawer
                anchor="right"
                open={showDrawer}
                onClose={toggleDrawer(false)}
            >
                <div className="draw-container " >

                    
                    <div className="img-drawer-container ">
                        <CancelIcon onClick={toggleDrawer(false)} fontSize="large" sx={{ color: "#FFF" }} style={{position: 'absolute', top:'10px', left:'10px', cursor: 'pointer'}}/>
                        <img className="img-drawer img-fluid" src={filteredPromotions !== null && filteredPromotions[currentIndex]?.image } alt="alt" />

                    </div>
                    
                    <div className="main-info-container w-100   p-4" >
                        <div className="w-100 p-2  drawer-shadown-conatiner">
                            <h2><small>{filteredPromotions !== null && filteredPromotions[currentIndex]?.establishment}</small> </h2>
                            <h2><b>{filteredPromotions !== null && filteredPromotions[currentIndex]?.percent}</b></h2>
                            <h2> { (filteredPromotions !== null && currentIndex!== undefined)  && filteredPromotions[currentIndex]?.title } </h2>
                            
                        </div>

                        <div className="w-100  pt-4  ">
                            <p className="">
                                {filteredPromotions !== null && filteredPromotions[currentIndex]?.description}
                            </p>
                        </div>

                        <hr />

                        <div className="w-100 p-2  days-drawer-container ">
                            <h3>Cuándo usarlo</h3>
                            <div className="row">
                            {filteredPromotions !== null && filteredPromotions[currentIndex]?.days.map((day, index)=> {
                                return(<div key={index} className="item-drawer-day">{day}</div>)
                            })}

                            </div>
                        </div>

                        <hr />
                        <div className="expire-container p-2">
                            <p className="pt-2">Vigencia: &nbsp;</p>
                            <h3><b>{filteredPromotions!==null && filteredPromotions[currentIndex]?.expire}</b></h3>
                        </div>

                        <hr />
                       <div className="expire-container p-2">
                           <p className="pt-2">Ubicación: &nbsp;</p>
                           <h3><b>{filteredPromotions!==null && filteredPromotions[currentIndex]?.address}</b></h3>
                       </div>


                        <hr />

                        <div className="legals ">
                            <h3>Legales</h3>

                            <p className="">
                                <small  dangerouslySetInnerHTML={{__html: String(filteredPromotions !== null && filteredPromotions[currentIndex]?.legals)}}>
                                    {/* {promotions !== null && promotions[currentIndex]?.legals} */}
                                </small>
                            </p>
                        </div>
                    </div>

                </div>
                
            </Drawer>
            </React.Fragment>
        }
        </div>
    </div> 
    }
</div>)
}
export default AllPromotions;
